import request from '@/utils/request'

export function listContactCareSmsTemplates() {
  return request({
    url: '/crmContactCareSms/template/list',
    method: 'get'
  })
}

export function saveContactCareSmsTemplate(data) {
  return request({
    url: '/crmContactCareSms/template/save',
    method: 'post',
    data
  })
}

export function removeContactCareSmsTemplate(id) {
  return request({
    url: `/crmContactCareSms/template/remove/${id}`,
    method: 'post'
  })
}

export function sendContactCareSms(data) {
  return request({
    url: '/crmContactCareSms/send',
    method: 'post',
    data
  })
}
